<template>
  <v-dialog v-model="dialog" max-width="600" @click:outside="cancel">
    <v-card flat>
      <v-card-title>
        Recipient list
        <v-spacer></v-spacer>
        <v-btn icon @click="cancel">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-subtitle>
        See who was sent this {{ isResources ? "Training Resource" : "Survey" }}
      </v-card-subtitle>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="overview.userRecords"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :footer-props="{
            'items-per-page-options': [10, 25, 50, 100]
          }"
        >
          <template v-slot:item.user.fullName="{ item }">
            <user-chip :user="item.user"></user-chip>
          </template>
          <template v-slot:item.completion="{ item }">
            <simple-engagement-text :engagement="item"></simple-engagement-text>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn
              text
              small
              class="light-background"
              color="info"
              v-if="item.finished > 0"
              @click="selectUser(item)"
            >
              Results
            </v-btn>
            <v-btn
              v-else
              text
              small
              class="light-background"
              color="lighttext"
              disabled
            >
              None
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import SimpleEngagementText from "@/components/reporting/SimpleEngagementText";
export default {
  name: "EngagementCardRecipientsDialog",
  components: { SimpleEngagementText },
  props: {
    isResources: { type: Boolean, default: false },
    overview: { type: Object }
  },
  data: () => ({
    dialog: false,
    sortBy: "completion",
    sortDesc: true,
    headers: [
      {
        text: "Name",
        value: "user.fullName"
      },
      { text: "Participation", value: "completion" },
      { text: "", value: "actions" }
    ]
  }),
  watch: {},
  computed: {
    ...mapGetters({})
  },
  methods: {
    cancel() {
      this.dialog = false;
    },
    showDialog() {
      this.dialog = true;
    },
    selectUser(item) {
      this.$emit("click", item.user.id);
      this.dialog = false;
    }
  }
};
</script>
